const categoryKeywords = [
  {
    ko_category: "프로그래밍 언어",
    eng_category: "Programming Languages",
    keywords: [
      "JavaScript",
      "Python",
      "Java",
      "C++",
      "C#",
      "Ruby",
      "PHP",
      "Swift",
      "Kotlin",
      "TypeScript",
      "Go",
      "Rust",
    ],
    unselectIcon: require("../assets/icons/programming_language_unselect.png"),
    selectIcon: require("../assets/icons/programming_language_select.png"),
  },
  {
    ko_category: "웹 개발",
    eng_category: "Web Development",
    keywords: [
      "HTML",
      "CSS",
      "JavaScript",
      "React",
      "Angular",
      "Vue",
      "Node.js",
      "Express",
      "Django",
      "Flask",
      "Spring",
      "PHP",
    ],
    unselectIcon: require("../assets/icons/web_development_unselect.png"),
    selectIcon: require("../assets/icons/web_development_select.png"),
  },
  {
    ko_category: "게임 개발",
    eng_category: "Game Development",
    keywords: [
      "Unity",
      "Unreal",
      "Godot",
      "GameMaker",
      "Pygame",
      "Phaser",
      "UDP",
      "Socket",
      "Minecraft",
      "Directx",
      "OpenGL",
      "Game",
    ],
    unselectIcon: require("../assets/icons/game_development_unselect.png"),
    selectIcon: require("../assets/icons/game_development_select.png"),
  },
  {
    ko_category: "모바일 개발",
    eng_category: "Mobile Development",
    keywords: [
      "Android",
      "Kotlin",
      "iOS",
      "Swift",
      "ReactNative",
      "Flutter",
      "Xamarin",
      "PhoneGap",
      "Ionic",
      "Cordova",
      "Corona",
      "Appcelerator",
    ],
    unselectIcon: require("../assets/icons/app_development_unselect.png"),
    selectIcon: require("../assets/icons/app_development_select.png"),
  },
  {
    ko_category: "데이터 사이언스",
    eng_category: "Data Science",
    keywords: [
      "Python",
      "R",
      "SQL",
      "Scala",
      "Julia",
      "Hadoop",
      "Spark",
      "SAS",
      "Matlab",
      "Tableau",
      "PowerBI",
      "Pandas",
    ],
    unselectIcon: require("../assets/icons/ai_unselect.png"),
    selectIcon: require("../assets/icons/ai_select.png"),
  },
];

export default categoryKeywords;
